import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'
import _ from 'lodash'

import Tooltip from 'gnos-tooltip'

import './style.scss'

export default class BasicInformations extends Component {
    static propTypes = {
        clickHandler: PropTypes.func,
        elementsDefinitions: PropTypes.array.isRequired,
        mainId: PropTypes.string.isRequired,
    }

    handleOnClick = (elementIdentifier) => () => {
        const { clickHandler, mainId } = this.props

        if (clickHandler) {
            clickHandler(elementIdentifier, mainId)
        }
    }

    render() {
        const { elementsDefinitions } = this.props

        return (
            <div className={cx('basic-informations')}>
                {_.map(elementsDefinitions, ({ title, top, bottom, key: elementIdentifier, tooltip }, key) => {
                    const emptyRow = (
                        <div className={cx('basic-information-row', !top && !bottom && 'full-empty')}>
                            <span className={cx('empty')} />
                        </div>
                    )
                    const titleRow = <div className={'basic-information-title'}>{title} </div>

                    if (!top && !bottom) {
                        return (
                            <div className={'basic-information-element'} key={`basic-information-element-${key}`}>
                                {titleRow}
                                {emptyRow}
                            </div>
                        )
                    }

                    const baseContent = (
                        <div
                            className={'basic-information-element'}
                            key={`basic-information-element-${key}`}
                            onClick={this.handleOnClick(elementIdentifier)}
                        >
                            {titleRow}
                            {top ? <div className={cx('basic-information-row', 'top')}>{top}</div> : emptyRow}
                            {bottom ? <div className={cx('basic-information-row', 'bottom')}>{bottom}</div> : emptyRow}
                            <div className={'basic-information-row'}>
                                <span className={'magnifier'} />
                            </div>
                        </div>
                    )

                    return tooltip ? (
                        <Tooltip
                            id={`basic_informations_tooltip_${elementIdentifier}-${key}`}
                            content={tooltip}
                            width={'450px'}
                            key={`basic_informations_element_${elementIdentifier}-${key}`}
                        >
                            {baseContent}
                        </Tooltip>
                    ) : (
                        baseContent
                    )
                })}
            </div>
        )
    }
}
